/* eslint-disable no-underscore-dangle */
import React, {useState} from 'react';

import InputContainer from 'components/InputContainer';

import ClearIcon from 'assets/svgs/actions/clear.svg';
import AddIcon from 'assets/svgs/actions/add-gray.svg';
import OutsideClickHandler from 'react-outside-click-handler';
import Folder from 'assets/svgs/common/folder.svg';
import GroupIcon from 'assets/svgs/company/groups.svg';
import {createDocumentFolder} from 'utils/fetch';
import MoveExisting from './MoveExisting';
import Search from './Search';

const Move = ({
  file,
  onClose,
  selected,
  breadcrumb,
  categoryType,
  userDetails,
  onMove,
  companyId,
}) => {
  const [folderName, setFolderName] = useState({name: '', isValid: null});
  const [currentSection, setCurrentSection] = useState('new');
  const [searchKey, setSearchKey] = useState('');
  const add = async () => {
    const obj = {name: folderName.name};

    const filters = {};

    if (selected) {
      filters.folderId = selected._id;
    }

    if (breadcrumb.length > 0) {
      filters.parentId = breadcrumb[0]._id;
    } else if (selected) {
      filters.parentId = selected._id;
    }
    obj.categoryType = categoryType;

    const folder = await createDocumentFolder({
      authToken: userDetails.authToken,
      filters,
      details: obj,
      companyId,
    });

    onMove(folder, file);
  };

  const AddFolder = () => (
    <div className="d-flex w-100 flex-column p-4  add-folder-container">
      <p>Create a new folder and group selected files into</p>
      <div>
        <InputContainer
          type="text"
          value={folderName.name}
          handleChange={(event) => {
            const newFolderName = {...folderName};
            newFolderName.name = event.target.value;
            setFolderName(newFolderName);
          }}
          inputClass="form-control"
        />
      </div>
      <div className="d-flex w-100 mt-2">
        <button className="cat-delete w-100" type="button" onClick={onClose}>
          <img src={ClearIcon} alt="" className="mr-2" />
          Cancel
        </button>
        <button
          type="button"
          className="ml-4 cat-delete w-100"
          onClick={() => {
            if (folderName.name) {
              add();
            }
          }}
        >
          <img src={AddIcon} alt="" className="mr-2" />
          Add Folder
        </button>
      </div>
    </div>
  );

  return (
    <div className="featured-img-popup">
      <div className="overlay"></div>

      <div className="box-popup d-flex justify-content-center align-items-center">
        <OutsideClickHandler
          onOutsideClick={() => {
            onClose();
          }}
        >
          <>
            <div className="content-popup small">
              <div className="d-flex">
                <div className="tab-nav position-relative">
                  <ul
                    className="nav nav-pills m-0 h-100"
                    id="pills-tab"
                    role="tablist"
                  >
                    <li className="nav-item h-50">
                      <a
                        className={`nav-link  h-100 ${
                          currentSection === 'new' ? 'active' : ''
                        }`}
                        onClick={(e) => {
                          e.preventDefault();
                          if (currentSection === 'new') return;

                          setCurrentSection('new');
                        }}
                        data-toggle="pill"
                        href="#test"
                        role="tab"
                        aria-controls="pills-upload-logo"
                        aria-selected="true"
                      >
                        <img alt="" className="mr-2" src={GroupIcon} />
                        <span className="tab-text">Add Folder</span>
                      </a>
                    </li>
                    <li className="nav-item h-50">
                      <a
                        className={`nav-link  h-100  ${
                          currentSection === 'exists' ? 'active' : ''
                        }`}
                        data-toggle="pill"
                        href="#test"
                        onClick={(e) => {
                          e.preventDefault();
                          if (currentSection === 'exists') return;
                          setCurrentSection('exists');
                        }}
                        role="tab"
                        aria-controls="pills-select-logo"
                        aria-selected="false"
                      >
                        <img alt="" className="mr-2" src={Folder} />
                        <span className="tab-text"> Existing Folder </span>
                      </a>
                    </li>
                  </ul>
                </div>

                <div className="tab-content file-tabs" id="pills-tabContent">
                  <div
                    className="tab-pane d-flex h-100 justify-content-center align-items-center "
                    id="pills-upload-logo"
                    role="tabpanel"
                    aria-labelledby="pills-upload-logo-tab"
                  >
                    {currentSection === 'new' ? (
                      AddFolder()
                    ) : (
                      <div className="d-flex filters-container flex-column w-100 px-4">
                        <p>
                          Group selected files into following existing folder
                        </p>
                        <Search
                          value={searchKey}
                          onChange={(val) => setSearchKey(val)}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {currentSection !== 'new' && (
                <MoveExisting
                  searchKey={searchKey}
                  setSearchKey={setSearchKey}
                  userDetails={userDetails}
                  selectedFolder={file}
                  onClose={onClose}
                  companyId={companyId}
                />
              )}
            </div>
          </>
        </OutsideClickHandler>
      </div>
    </div>
  );
};

export default Move;
